import { render, staticRenderFns } from "./RegisterProtocol.vue?vue&type=template&id=f9699b26&scoped=true&"
import script from "./RegisterProtocol.vue?vue&type=script&lang=js&"
export * from "./RegisterProtocol.vue?vue&type=script&lang=js&"
import style0 from "./RegisterProtocol.vue?vue&type=style&index=0&id=f9699b26&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9699b26",
  null
  
)

export default component.exports